(() => {
  const initAuroraCart = (root) => {
    if (!root || root.dataset.auroraCartReady === 'true') return;
    root.dataset.auroraCartReady = 'true';

    const form = root.querySelector('[data-aurora-cart-form]');
    if (!form) return;

    let submitTimer;
    const submitUpdate = () => {
      window.clearTimeout(submitTimer);
      submitTimer = window.setTimeout(() => {
        form.setAttribute('aria-busy', 'true');
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }, 420);
    };

    root.querySelectorAll('[data-aurora-cart-line]').forEach((line) => {
      const input = line.querySelector('[data-aurora-quantity-input]');
      const minus = line.querySelector('[data-aurora-qty-minus]');
      const plus = line.querySelector('[data-aurora-qty-plus]');

      if (!input) return;

      minus?.addEventListener('click', () => {
        const current = Number.parseInt(input.value, 10) || 1;
        input.value = String(Math.max(1, current - 1));
        submitUpdate();
      });

      plus?.addEventListener('click', () => {
        const current = Number.parseInt(input.value, 10) || 1;
        input.value = String(current + 1);
        submitUpdate();
      });

      input.addEventListener('change', () => {
        const value = Number.parseInt(input.value, 10);
        input.value = String(Number.isFinite(value) && value > 0 ? value : 1);
        submitUpdate();
      });
    });

    const checkout = root.querySelector('[data-aurora-checkout]');
    checkout?.addEventListener('click', () => {
      checkout.setAttribute('aria-busy', 'true');
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-aurora-cart]').forEach(initAuroraCart);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();